import './availabilityComponent.scss';
import 'moment/locale/fr';

import React, { useMemo } from 'react';

import { IAppliance } from '../../interfaces';
import InStockIcon from '../../images/englander-icons/In-Stock-Icon.svg';
import PreOrderIcon from '../../images/englander-icons/Preorder-Icon.svg';
import moment from 'moment';
import { useAvailabilityInfo } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/AddToCartButton';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export default function AvailabilityComponent(props: { product: IAppliance }) {
    const { product } = props;
    const availabilityInfo = useAvailabilityInfo(product);
    const { t } = useTranslation('layout');
    const { currentLocale } = usePageLocalization();
    
    moment.locale('en');
    let nextAvailableDate = moment(availabilityInfo.nextShipDate).format(
        'MMM Do YYYY'
    );
    if (currentLocale === 'fr_CA') {
        moment.locale('fr');
        nextAvailableDate = moment(availabilityInfo.nextShipDate).format(
            'DD MMM YYYY'
        );
    }

    const status = useMemo(
        () => availabilityInfo.status,
        [availabilityInfo.status]
    );

    const getStatusText = () => {
        if (status === 'available') {
            return t('addToCartBtn.available');
        }
        if (status === 'preorder') {
            return t('addToCartBtn.available-pre-order');            
        }
        return t('addToCartBtn.not-in-stock');
    };
    
    return (
        <div className='availability-component'>
            <span className='status'>
                <img
                    src={availabilityInfo.status === 'preorder' ? PreOrderIcon : InStockIcon}
                    alt=''
                />
                {getStatusText()}
            </span>
            {availabilityInfo.status === 'preorder' && (
                <span className='date'>
                    {t('addToCartBtn.dispo', {
                        date: nextAvailableDate,
                    }).replace(':', '')}
                </span>
            )}
        </div>
    );
}
